export default "__VITE_ASSET__479fb96f__"